import React, { useEffect, useState } from 'react';
import { MessageCircle, X } from 'lucide-react';

const WhatsAppButton = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);
  
  const phoneNumber = "919887068888"; // WhatsApp number
  const message = "Hello RO Dekho! I need help with RO water purifier service.";

  useEffect(() => {
    // Show button after 2 seconds
    const timer = setTimeout(() => {
      setIsVisible(true);
      // Show tooltip for first-time visitors
      const tooltipShown = localStorage.getItem('whatsapp_tooltip_shown');
      if (!tooltipShown) {
        setShowTooltip(true);
        setTimeout(() => {
          setShowTooltip(false);
          localStorage.setItem('whatsapp_tooltip_shown', 'true');
        }, 5000);
      }
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  const handleClick = () => {
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };

  const closeTooltip = () => {
    setShowTooltip(false);
    localStorage.setItem('whatsapp_tooltip_shown', 'true');
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-6 right-6 z-50">
      {/* Tooltip */}
      {showTooltip && (
        <div className="absolute bottom-20 right-0 bg-white rounded-lg shadow-2xl p-4 w-64 animate-in slide-in-from-bottom-5">
          <button
            onClick={closeTooltip}
            className="absolute top-2 right-2 text-gray-400 hover:text-gray-600"
          >
            <X size={16} />
          </button>
          <div className="flex items-start gap-3">
            <div className="bg-green-100 p-2 rounded-full flex-shrink-0">
              <MessageCircle className="text-green-600" size={20} />
            </div>
            <div>
              <p className="font-semibold text-gray-900 text-sm mb-1">
                Need Help? Chat with us!
              </p>
              <p className="text-xs text-gray-600">
                Get instant support on WhatsApp
              </p>
            </div>
          </div>
        </div>
      )}

      {/* WhatsApp Button */}
      <button
        onClick={handleClick}
        className="group relative bg-green-500 hover:bg-green-600 text-white rounded-full p-4 shadow-2xl hover:shadow-green-500/50 transition-all duration-300 transform hover:scale-110 animate-in zoom-in"
        aria-label="Chat on WhatsApp"
      >
        {/* Pulse Animation */}
        <span className="absolute inset-0 rounded-full bg-green-500 animate-ping opacity-75"></span>
        
        {/* Icon */}
        <MessageCircle size={28} className="relative z-10" />
        
        {/* Online Indicator */}
        <span className="absolute top-0 right-0 w-4 h-4 bg-green-400 border-2 border-white rounded-full"></span>
      </button>

      {/* Hover Text */}
      <div className="absolute bottom-full right-0 mb-2 opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
        <div className="bg-gray-900 text-white text-sm px-3 py-2 rounded-lg whitespace-nowrap">
          Chat with us on WhatsApp
        </div>
      </div>
    </div>
  );
};

export default WhatsAppButton;
